/** @jsxImportSource @gasman/smush */

import './menu.css';

import { Component } from '@gasman/smush';

class Menu extends Component {
    constructor(app) {
        super();
        this.app = app;
        this.song = null;

        let showSampleModal = () => {
            this.app.sampleEditorModal.show();
        };
        let showOrnamentModal = () => {
            this.app.ornamentEditorModal.show();
        };

        this.menuBar = (
            <div class="menu">
                <button onclick={showSampleModal}>Samples</button>
                <button onclick={showOrnamentModal}>Ornaments</button>
            </div>
        );
    }

    render(container) {
        container.appendChild(this.menuBar);
    }

    bind(song) {
        this.song = song;
    }
    unbind() {
        this.song = null;
    }
}

export { Menu };
